import { gql } from "@apollo/client";

export const GET_BUSINESS_ALERT_ROUTING_SETTINGS = gql`
  query GetBusinessAlertRoutingSettings($businessId: ID!) {
    getBusinessAlertRoutingSettings(businessId: $businessId) {
      businessId
      policyJson
      residentAssignmentsJson
      updatedAt
    }
  }
`;
